module.exports = __webpack_public_path__ + "media/images/header_image-2e246f7ef48516ce87beaad96771a442.svg";